export default {

    API_MAIL_URL: 'https://site-api.telego.rs/api/v1.0/web',
    API_ACTION_CONTACT: '/contact',
    API_CAREER_URL: 'https://telego-api.fenix/api/documentation/web',
    API_ACTION_CAREER: '/careers',

}
